"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcAggValue = void 0;
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey"));
function calcAggValue(aggs, field) {
    if (!aggs)
        return undefined;
    const agg = aggs.find(theAgg => field.key === ViewFieldKey_1.default.QUESTIONANSWER
        ? theAgg.fieldKey === field.key && theAgg.questionNodeId === field.questionNodeId
        : theAgg.fieldKey === field.key);
    return agg ? agg.value : undefined;
}
exports.calcAggValue = calcAggValue;
exports.default = calcAggValue;
